<template>
    <div id="passwordResolution">
        <el-breadcrumb separator="/" class="breadcrumb">
          <el-breadcrumb-item>业务设置</el-breadcrumb-item>
          <el-breadcrumb-item>淘口令解析</el-breadcrumb-item>
        </el-breadcrumb>
        <section class="content-warpper content-warpper-main">
            <el-form label-width="90px">
              <div class="divStyle">
                <div class="titleLable">
                  淘口令
                </div>
                <el-input type="textarea" placeholder="请输入淘口令，每次一条" resize="none" v-model="workTitle"  size="small"></el-input>
              </div>
            </el-form>
            <el-form label-width="90px">
              <div class="divStyle">
                <div class="titleLable"></div>
                <el-button type="primary" @click="saveReport" size="small">解析淘口令</el-button>
                <el-button @click="empty" size="small" type="TheCustom">清空</el-button>
              </div>
            </el-form>
            <el-form label-width="90px">
              <div class="divStyle">
                <div class="titleLable">
                  链接地址
                </div>
                <el-input type="textarea" placeholder="请输入备注说明，请保持在200字以内" resize="none" v-model="linkAddress"  size="small"></el-input>
              </div>
            </el-form>
            <el-form label-width="90px">
              <div class="divStyle">
                <div class="titleLable"></div>
                <el-button @click="cancel" size="small" type="TheCustom">复制链接</el-button>
              </div>
            </el-form>
        </section>
    </div>
</template>

<script>
  import axios from "axios";
  import { mapGetters } from 'vuex';
  import {mapActions} from "vuex";
  export default {
    name: "passwordResolution",
    data:function(){
      return{
        workTitle: '',
        linkAddress: '',
      }
    },
    methods:{
      // 解析淘口令
      saveReport(){
        if(this.workTitle == ''){
          this.$message.error('请填写淘口令');
          return
        }
        //提交
        let params={
          vekey:"V00003012Y39715718",
          para: this.workTitle,
          parsetkl: "1",
        }
        fetch({
          url: "taobao",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.error == '0'){
            this.$message({
              message: res.msg,
              type: 'success'
            });
            if (res.data && res.data.click_url) {
              this.linkAddress = res.data.click_url
            } else {
              this.linkAddress = res.data
            }

          } else {
            this.$message.error(res.msg)
          }
        })
      },
      // 清空
      empty() {
        this.workTitle = ''
      },
      // 复制链接
      cancel() {
        if(this.linkAddress == ''){
          return
        }
        let oInput = document.createElement('input');
  			oInput.value = this.linkAddress;
  			document.body.appendChild(oInput);
  			oInput.select(); // 选择对象;
  			document.execCommand("Copy"); // 执行浏览器复制命令
  			this.$message({
  				message: '复制成功',
  				type: 'success'
  			});
  			oInput.remove()
      },
    }
  }
</script>
<style lang="scss">
  #passwordResolution{
    .divStyle {
      display: flex;
      margin-left: -7px;
      margin-bottom: 24px;
    }
    .titleLable {
      width: 100px;
      margin-bottom: 22px;
      text-align: right;
      vertical-align: middle;
      float: left;
      font-size: 14px;
      color: #606266;
      line-height: 32px;
      padding: 0 12px 0 0;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }
    .trumpet_icon_container{
        font-size: 12px;
        color:#faad14;
        background:#fffbf3;
        width: 507px;
        height:28px ;
        line-height: 28px;
        margin-bottom: 20px;
        img{
            width: 14px;
            height: 12px;
            vertical-align: middle;
        }
    }

    .el-textarea__inner,.el-textarea{
        width: 425px;
        height: 167px;
    }
    .el-button--primary {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }
    .el-button--primary:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
    .el-button--TheCustom {
      color: #666;
      border-color: #D9D9D9;
      background-color: #fff;
    }
    .el-button--TheCustom:hover  {
      color: #666;
      border-color: #ded2b8;
      background-color: #faf9f5;
    }
  }
</style>
